import type { ListTableLazyHandlerProps } from "./list-table-lazy-handler.type";

import { useEffect, useState } from "react";

import {
  getListLazyHeight,
  getListLazyThreshold,
  useListContext,
} from "@/modules/list";

import { getListTableContentNode } from "./list-table-lazy-handler.helper";

export const useListTableLazyHandler = ({
  lazyOptions,
  tableRef,
}: ListTableLazyHandlerProps) => {
  const { onFetchNextPage } = useListContext();
  const threshold = getListLazyThreshold(lazyOptions);

  const [currentClientHeight, setCurrentClientHeight] = useState<number | null>(
    null
  );

  /**
   * Handle lazy loading by filling the space compared to max-height value
   */
  useEffect(() => {
    const table = getListTableContentNode(tableRef);

    if (!table) return;

    const height = table.clientHeight;
    const maxHeight = getListLazyHeight(lazyOptions);

    if (height < maxHeight && height !== currentClientHeight)
      onFetchNextPage?.();

    setCurrentClientHeight(height);
  }, [lazyOptions, onFetchNextPage]);

  /**
   * Handle lazy loading on table scroll
   */
  useEffect(() => {
    const table = getListTableContentNode(tableRef);

    if (!table) return;

    table.onscroll = (e) => {
      if (!e.target) return;

      const { scrollHeight, scrollTop, clientHeight } = e.target as HTMLElement;
      const remainingScrollToBottom = scrollHeight - scrollTop - clientHeight;

      if (remainingScrollToBottom <= threshold) onFetchNextPage?.();
    };
  }, [threshold, onFetchNextPage]);
};
